import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
export const copyToClipboard = (copyText) => {
  copy(copyText);
  toast.success("Copied");
};
